import {
  ADD_CONTRACT,
  ADD_DOCUMENT,
  ADD_TYPE_CONTRACT,
  DELETE_DOCUMENT,
  DELETE_FILE_DOCUMENT,
  FETCH_CONTRACTS,
  FETCH_DOCUMENTS,
  RENAME_DOCUMENT,
  SET_ACTIVE_DOCUMENT,
  SET_CONTRACTS,
  SET_CONTRAGENT_ID,
  SET_DOCUMENTS,
  SET_LOADING,
  SIGN_DOCUMENT,
  UPLOAD_FILE_IMG_DOCUMENT,
} from './actions/contracts'
import { Message } from 'element-ui'

import { RepositoryFactory } from '@/api/RepositoryFactory'
const contractsRepository = RepositoryFactory.get('contractsRepository')
const fileRepository = RepositoryFactory.get('file')
const DocumentRepository = RepositoryFactory.get('document')

export default {
  state: {
    contracts: {},
    documents: null,
    loading: false,
    contragentId: null,
  },
  getters: {
    getContracts(state) {
      return state.contracts
    },
    getDocuments(state) {
      return state.documents
    },
    getContragentd(state) {
      return state.contragentId
    },
    getContractsLoading(state) {
      return state.loading
    },
  },
  actions: {
    [FETCH_DOCUMENTS]: ({ commit }, id) => {
      commit(SET_LOADING, true)
      contractsRepository
        .getDocumentsInContract(id)
        .then(res => commit(SET_CONTRACTS, res.data))
        .catch(err => {
          Message({
            type: 'error',
            showClose: true,
            message: 'Произошла неизвестная ошибка',
          })
          console.log(err)
        })
        .finally(() => commit(SET_LOADING, false))
    },
    [FETCH_CONTRACTS]: ({ commit, dispatch }, contragent_id) => {
      commit(SET_LOADING, true)
      commit(SET_CONTRAGENT_ID, contragent_id)
      contractsRepository
        .getContractsList(contragent_id)
        .then(res => {
          commit(SET_CONTRACTS, res.data)
          dispatch('fetchContragentsStatistics', null, {
            root: true,
          })
        })
        .catch(err => {
          Message({
            type: 'error',
            showClose: true,
            message: 'Произошла неизвестная ошибка',
          })
          console.log(err)
        })
        .finally(() => commit(SET_LOADING, false))
    },
    [ADD_CONTRACT]: ({ commit, dispatch }, data) => {
      commit(SET_LOADING, true)
      contractsRepository
        .post(data)
        .then(res => {
          dispatch('fetchContragentByInn', data.inn, {
            root: true,
          })
          Message({
            type: 'success',
            showClose: true,
            message: 'Контракт создан',
          })
        })
        .catch(err => {
          Message({
            type: 'error',
            showClose: true,
            message: 'Произошла неизвестная ошибка',
          })
          console.log(err)
        })
        .finally(() => commit(SET_LOADING, false))
    },
    [ADD_TYPE_CONTRACT]: ({ commit, dispatch }, data) => {
      commit(SET_LOADING, true)
      contractsRepository
        .addTypeContract(data)
        .then(res => {
          dispatch('fetchContragentByInn', data.inn, {
            root: true,
          })
          Message({
            type: 'success',
            showClose: true,
            message: 'Сохранено успешно',
          })
        })
        .catch(err => {
          Message({
            type: 'error',
            showClose: true,
            message: 'Произошла неизвестная ошибка',
          })
          console.log(err)
        })
        .finally(() => commit(SET_LOADING, false))
    },
    [ADD_DOCUMENT]: ({ commit, dispatch, state }, data) => {
      commit(SET_LOADING, true)
      contractsRepository
        .addDocumentToContract(data)
        .then(() => {
          dispatch('fetchContragentByInn', data.inn, {
            root: true,
          })
          Message({
            type: 'success',
            showClose: true,
            message: 'Сохранено успешно',
          })
        })
        .catch(err => {
          Message({
            type: 'error',
            showClose: true,
            message: 'Произошла неизвестная ошибка',
          })
          console.log(err)
        })
        .finally(() => commit(SET_LOADING, false))
    },
    [RENAME_DOCUMENT]: ({ commit, dispatch, state }, data) => {
      commit(SET_LOADING, true)
      DocumentRepository.rename(data)
        .then(() => {
          dispatch('fetchContragentByInn', data.inn, {
            root: true,
          })
          Message({
            type: 'success',
            showClose: true,
            message: 'Сохранено успешно',
          })
        })
        .catch(err => {
          Message({
            type: 'error',
            showClose: true,
            message: 'Произошла неизвестная ошибка',
          })
          console.log(err)
        })
        .finally(() => commit(SET_LOADING, false))
    },
    [DELETE_FILE_DOCUMENT]: ({ commit, dispatch, state }, data) => {
      commit(SET_LOADING, true)
      fileRepository
        .dellOne(data)
        .then(() => {
          Message({
            type: 'success',
            showClose: true,
            message: 'Удалено успешно',
          })

          return true
        })
        .catch(err => {
          Message({
            type: 'error',
            showClose: true,
            message: 'Произошла неизвестная ошибка',
          })
          console.log(err)
        })
        .finally(() => commit(SET_LOADING, false))
    },
    [UPLOAD_FILE_IMG_DOCUMENT]: (
      { commit, dispatch, state },
      param1,
      param2,
    ) => {
      commit(SET_LOADING, true)

      fileRepository
        .upload(param1, param2)
        .then(response => {
          if (response.data.id === undefined) {
            Message({
              type: 'error',
              showClose: true,
              message: 'Ошибка при загрузке попробуйте еще раз. Ошибка #B',
            })
          }

          if (response.data.id !== undefined) {
            Message({
              type: 'success',
              showClose: true,
              message: 'Сохранено успешно',
            })
          }

          return true
        })
        .catch(err => {
          const message =
            err.response?.data?.errors?.file_path[0] ||
            'Ошибка при загрузке попробуйте еще раз.'

          Message({
            type: 'error',
            showClose: true,
            message,
          })
        })
        .finally(() => commit(SET_LOADING, false))
    },
    [SIGN_DOCUMENT]: ({ commit, dispatch, state }, data) => {
      commit(SET_LOADING, true)
      contractsRepository
        .signDocumentInContract(data)
        .then(() => {
          dispatch('fetchContragentByInn', data.inn, {
            root: true,
          })
          Message({
            type: 'success',
            showClose: true,
            message: 'Сохранено успешно',
          })
        })
        .catch(err => {
          Message({
            type: 'error',
            showClose: true,
            message: 'Произошла неизвестная ошибка',
          })
          console.log(err)
        })
        .finally(() => commit(SET_LOADING, false))
    },
    [SET_ACTIVE_DOCUMENT]: ({ commit, dispatch, state }, data) => {
      commit(SET_LOADING, true)
      contractsRepository
        .activeDocumentInContract(data)
        .then(() => {
          dispatch('fetchContragentByInn', data.inn, {
            root: true,
          })
          Message({
            type: 'success',
            showClose: true,
            message: 'Сохранено успешно',
          })
        })
        .catch(err => {
          Message({
            type: 'error',
            showClose: true,
            message: 'Произошла неизвестная ошибка',
          })
          console.log(err)
        })
        .finally(() => commit(SET_LOADING, false))
    },
    [DELETE_DOCUMENT]: ({ commit, dispatch, state }, data) => {
      commit(SET_LOADING, true)
      contractsRepository
        .deleteDocumentFromContract(data)
        .then(() => {
          dispatch('fetchContragentByInn', data.inn, {
            root: true,
          })
          Message({
            type: 'success',
            showClose: true,
            message: 'Удалено успешно',
          })
        })
        .catch(err => {
          Message({
            type: 'error',
            showClose: true,
            message: 'Произошла неизвестная ошибка',
          })

          console.log(err)
        })
        .finally(() => commit(SET_LOADING, false))
    },
  },
  mutations: {
    [SET_DOCUMENTS](state, payload) {
      state.documents = payload
    },
    [SET_CONTRAGENT_ID](state, payload) {
      state.contragentId = payload
    },
    [SET_LOADING](state, payload) {
      state.loading = payload
    },
    [SET_CONTRACTS](state, payload) {
      state.contracts = payload
    },
  },
}
